import type { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

import { Page } from '@ohpen/enso-ui';

import styles from './styles.module.css';

/** Stands in for a section that has a route and a menu entry but no screens yet. */
export const ComingSoon = ({ sectionKey }: { sectionKey: string }): ReactElement => {
  const { t } = useTranslation();

  return (
    <Page>
      <Page.Title>{t(`config.sections.${sectionKey}`)}</Page.Title>
      <Page.Content fill>
        <div className={styles.comingSoonBody}>
          <p className={styles.comingSoonDescription}>{t(`config.comingSoon.descriptions.${sectionKey}`)}</p>
          <p className={styles.comingSoonNote}>{t('config.comingSoon.notBuiltYet')}</p>
        </div>
      </Page.Content>
    </Page>
  );
};
